module.exports = __webpack_public_path__ + "media/icons/sprowadzony-active-15a60333.png";